Footer = {
    pinBottom: function(){
        var gap = $(window).width() > 768 ? 0: 0;
        var height = $(window).innerHeight() - $('.row.footer').outerHeight() - $('.row.footer-logos').outerHeight() - $('.row.header').outerHeight() - gap -1;
        $('body > .page-content').css({minHeight: height});

    }
}